import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import throttle from 'lodash/throttle';
import Cookies from 'js-cookie';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import Social from './components/social';
import Categories from './components/categories';
import Link from 'react-router-dom/Link';
import outerHeight from '../../../utils/outerheight_util';
import matchMediaDesktop from '../../../utils/client_util';
import Notice from './components/notice';
import { UserConsumer } from '../context/userContext';
import EventModel from '../../../utils/tracking/models';

class Masthead extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
      active: true,
      isMobile: null,
      hideTitle: false,
      expandUser: false,
      cantClose: true,
      withPiano: false
    };

    // NOTIFICATION KILLSWITCH
    this.showNotice = !isEmpty(props.homepageTopPromo);

    this.lastScroll = 0;
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeActiveMenu = this.closeActiveMenu.bind(this);
    this.navTimeout = undefined;
    this.mastcontainer = React.createRef();
    this.handleTopNavAdPositioning = this.handleTopNavAdPositioning.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.resize = this.resize.bind(this);
    this.mouseOverUser = this.mouseOverUser.bind(this);
    this.mouseLeavingUser = this.mouseLeavingUser.bind(this);
    this.closeUser = this.closeUser.bind(this);
  }

  componentDidMount() {
    if (typeof window.queryly !== 'undefined') {
      window.queryly.init(
        'c99eafd2993b450c',
        document.getElementsByClassName('masthead__search')
      );
    }

    this.handleNavScroll = throttle(this.handleNavScroll.bind(this), 100);
    window.addEventListener('scroll', this.handleNavScroll);

    window.addEventListener('resize', this.resize);
    this.resize();

    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.addEventListener('scroll', this.handleTopNavAdPositioning);
    }

    this.shouldLoadWithPiano();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleNavScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.removeEventListener('scroll', this.handleTopNavAdPositioning);
    }
  }

  shouldLoadWithPiano() {
    const canUsePiano = Cookies.get('_pc_v1uc') === '282020';
    this.setState({
      withPiano: canUsePiano
    });
  }

  trackLoginClick() {
    const loginClickEvent = new EventModel(
      `login nav link`,
      `login link`,
      `click`,
      `nav-login`,
      `1 | 5`
    );

    loginClickEvent.triggerTrackingEvent(
      'login-nav',
      loginClickEvent.getTrackingObject()
    );
  }

  handleNavScroll() {
    const currentScroll = window.pageYOffset;
    const latestScroll = this.lastScroll;

    if (currentScroll > latestScroll && latestScroll > 1 && this.state.active) {
      this.setState({ active: false });
    } else if (
      (currentScroll < latestScroll || latestScroll < 1) &&
      !this.state.active
    ) {
      this.setState({ active: true });
    }
    this.lastScroll = currentScroll;

    if (this.state.expandUser) {
      this.mouseLeavingUser();
    }
  }

  handleTopNavAdPositioning() {
    if (!this.topNavAd) {
      this.topNavAd = document.querySelector('.homepage-page__ff-ad-container');
    }

    if (this.topNavAd) {
      const height = outerHeight(this.topNavAd);
      // debugger;
      if (window.scrollY >= height) {
        this.mastcontainer.style = 'position: fixed;';
      } else {
        this.mastcontainer.style = 'position: relative;';
      }
    }
  }

  handleResize() {
    window.removeEventListener('scroll', this.handleTopNavAdPositioning);
    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.addEventListener('scroll', this.handleTopNavAdPositioning);
      this.handleTopNavAdPositioning();
    }
  }

  toggleMenu() {
    this.setState({ menu: !this.state.menu });
  }

  closeActiveMenu() {
    this.navTimeout = setTimeout(() => {
      this.setState({ active: false });
    }, 2000);
  }

  resize() {
    const isMobile = window.innerWidth <= 913;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }

  mouseOverUser() {
    let { hideTitle } = this.state;
    if (this.state.isMobile) {
      hideTitle = true;
    }

    setTimeout(() => {
      this.setState({
        cantClose: false
      });
    }, 500);

    this.setState({
      expandUser: true,
      hideTitle
    });
  }

  mouseLeavingUser() {
    let { hideTitle } = this.state;
    if (this.state.isMobile || hideTitle === true) {
      hideTitle = false;
    }

    this.setState({
      expandUser: false,
      hideTitle
    });
  }

  closeUser() {
    if (!this.state.cantClose && this.state.isMobile && this.state.expandUser) {
      this.setState({
        hideTitle: false,
        expandUser: false,
        cantClose: true
      });
    } else {
      this.mouseOverUser();
    }
  }

  render() {
    const {
      topics,
      channels,
      trackClick,
      config,
      activeCategory,
      hasTopNavAd
    } = this.props;
    const { menu, active, withPiano } = this.state;
    const site = get(this.props.config, 'site', '');
    const social = get(mainMenuContext, `social.${site}`, []);

    return (
      <React.Fragment>
        {this.showNotice && (
          <Notice homepageTopPromo={this.props.homepageTopPromo} />
        )}
        <div
          ref={mastcontainer => {
            this.mastcontainer = mastcontainer;
          }}
          className={hasTopNavAd ? 'masthead masthead--top-nav-ad' : 'masthead'}
          onMouseEnter={() => {
            clearTimeout(this.navTimeout);
            this.setState({ active: true });
          }}
          onMouseLeave={this.closeActiveMenu}
        >
          <header className="masthead__header">
            {this.state.hideTitle ? (
              ''
            ) : (
              <Link to="/" className="masthead__title">
                <h2>Fast Company</h2>
              </Link>
            )}
            <button
              onClick={this.toggleMenu}
              className="masthead__menu"
              aria-label="dropdown menu"
            />
            <div className="masthead__interactive">
              <Social data={social} trackClick={trackClick} />
              {withPiano && (
                <UserConsumer>
                  {({ isLoggedIn, showScreen, logoutUser }) => {
                    if (isLoggedIn) {
                      return (
                        <div
                          className={`masthead__user ${
                            this.state.expandUser ? 'masthead__user--hover' : ''
                          }`}
                          onMouseEnter={this.mouseOverUser}
                          onMouseLeave={this.mouseLeavingUser}
                        >
                          <span
                            className="masthead__user-label masthead__user-logo"
                            onClick={this.closeUser}
                          >
                            <img
                              alt="user account icon"
                              src="https://images.fastcompany.net/image/upload/v1612289973/fcweb/account-icon_hqgzbi.svg"
                            />
                          </span>
                          <ul className="masthead__user-list">
                            <li className="masthead__user-item">
                              <a
                                className="masthead__user-button"
                                rel="noopener noreferrer"
                                href="/myaccount"
                              >
                                <p>Account</p>
                              </a>
                            </li>
                            <li className="masthead__user-item">
                              <a
                                className="masthead__user-button"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={e => {
                                  e.preventDefault();
                                  logoutUser();
                                  this.mouseLeavingUser();
                                }}
                              >
                                <p className="logoutLink">Logout</p>
                              </a>
                            </li>
                          </ul>
                        </div>
                      );
                    }
                    return (
                      <div
                        className="masthead__user-login"
                        onClick={e => {
                          e.preventDefault();
                          showScreen('login', 'modal');

                          /**
                           * NOTE: this could live in context `showScreen` function
                           * via a switch statement if the logic is generic enough.
                           */
                          this.trackLoginClick();
                        }}
                      >
                        <span className="masthead__user-label">Login</span>
                      </div>
                    );
                  }}
                </UserConsumer>
              )}
              <button
                className={`masthead__search ${
                  withPiano ? 'withPiano' : 'nah'
                }`}
                aria-label="site search"
              >
                <i className="icon-search-glass" />
              </button>
            </div>
          </header>
          <Categories
            topics={topics}
            channels={channels}
            active={active}
            activeCategory={activeCategory}
            trackClick={trackClick}
          />
          <MainMenu
            closeMenu={this.toggleMenu}
            mainMenuVisible={menu}
            config={config}
            topics={topics}
            {...mainMenuContext}
          />
        </div>
      </React.Fragment>
    );
  }
}

Masthead.propTypes = {
  config: PropTypes.shape({}).isRequired,
  topics: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  trackClick: PropTypes.func,
  activeCategory: PropTypes.string.isRequired,
  hasTopNavAd: PropTypes.bool.isRequired,
  homepageTopPromo: PropTypes.shape({})
};

Masthead.defaultProps = {
  trackClick: () => {},
  homepageTopPromo: {}
};

export default Masthead;
